<mat-card (click)="navigateToRoute(routerLink)"   class="dashboard-card summary-card" style="width: 90%;" [ngClass]="{
  'oem-card': cardType === 'oem',
  'distributor-card': cardType === 'distributor',
  'end-customer-card': cardType === 'end-customer',
  'revenue-card': cardType === 'revenue',
  'oem-dashboard-card': cardType === 'oem-dashboard',
  'distributor-dashboard-card': cardType === 'distributor-dashboard'
}" >
    <mat-card-content class="dashboard-card-content" [ngClass]="{
      'oem-cardContent': cardType === 'oem-dashboard',
      'distributor-cardContent': cardType === 'distributor-dashboard',
    }" (click)="$event.stopPropagation()" >
        <div class="metric-info" [ngStyle]="{'cursor': cardType === 'oem' || cardType === 'distributor' || cardType === 'end-customer' ? 'pointer' : 'default'}" (click)="routelinkNavigate($event)">
          <span><img alt=".." class="metric-icon" src="{{metric?.icon}}"></span>
          <div class="label-value">
            <h3 class="label">
              <span  class="metric-label" *ngIf="cardType === 'end-customer'; else defaultLabel">
                {{ metric?.label | pascalToReadable }}
              </span>
              <ng-template #defaultLabel>
                <span class="metric-label">{{ metric?.label }}</span>
              </ng-template>
            </h3>
            <h2 class="value" clas=" align">{{ metric?.value }}</h2>
          </div>

        </div>
        <div *ngIf="cardType === 'oem-dashboard'" class="metric-button" >
          <a (click)="moreClicked($event)" mat-button  class="metric-button-text" >more</a>
        </div>
        <div *ngIf="cardType === 'distributor-dashboard'" class="metric-button">
          <a (click)="moreClicked($event)" mat-button  class="distributor-metric-button-text" >more</a>
        </div>
        <ng-content></ng-content>
    </mat-card-content>

 </mat-card>
